import React from 'react';
import {Paragraph, Title, Image} from './../../Basics';

const Particle17 = () => (<div>

  <Title>These robotic suits are already available</Title>
  <Paragraph>
   At this point in time, very few mobility-impaired people walk using an exoskeleton. The main reasons for
   this situation are price and weight. Many of these devices cost between 70 000 and 100 000 Swiss francs.
   In addition, they are usually unwieldy and heavy. For example, the model created by the Swiss Varileg Team,
   present at the Cybathlon but not yet ready for market, weighs 35 kilograms. However, increasingly light and cheap
   models are in development or emerging in the market:
  </Paragraph>

  <Image
    source={require('./17_Bild_1_ReWalk.jpg')}
    title='Abbildung Exoskelett Rewalk'
    caption='At 20 kilograms, the exoskeleton engineered by the Israeli company Rewalk, also present at the Cybathlon,
    is significantly lighter. In Italy and the United States, where costs are covered by insurance, some individuals are
    already using this device. Rewalk is the result of extended development of military technology.'
  />

  <Image
    source={require('./17_Bild_2_SuitX.jpg')}
    title='Abbildung Exoskelett Rewalk'
    caption='The SuitX company, which emerged from the University of Berkeley, seems to have achieved a breakthrough at
    the beginning of 2016. The “Phoenix” exoskeleton weighs only 12 kilograms and, at 40 000 Swiss francs, is only half the
    price of conventional models.'
  />
 
  <Image
    source={require('./17_Bild_3_infografik-xosoft.jpg')}
    title='Abbildung Exoskelett Rewalk'
    caption='Within the scope of the XoSoft EU project, the Zürcher Hochschule für Angewandte Wissenschaften ZHAW is
    currently developing a special model. The future product, a soft exoskeleton, will resemble a pair of leggings that
    can be worn under clothing. However, this model is not designed to support full body weight. It is therefore more
    suitable for individuals presenting muscle weakness than for patients suffering total leg paralysis.'
  />



</div>);

export default Particle17;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle17/Particle17_EN.js
 **/